<template>
    <div class="home">
        <home-header></home-header>
        <div class="base-padding">
            <!-- <home-bill></home-bill> -->
            <home-menu></home-menu>
            <home-amap></home-amap>
        </div>
    </div>
</template>
<script>
import HomeHeader from "@/components/home/home-header.vue";
import HomeBill from "@/components/home/home-bill.vue";
import HomeMenu from "@/components/home/home-menu.vue";
import HomeAmap from "@/components/home/home-amap.vue";
import Tabbar from "@/components/tabbar/index.vue";
export default {
    name: "Home",
    components: {
        HomeHeader,
        HomeBill,
        HomeMenu,
        HomeAmap,
        Tabbar,
    },
    data() {
        return {};
    },
    methods: {},
    activated() {
        console.log("我被缓存了");
    },
    deactivated() {
        console.log("我退出了");
    },
};
</script>
<style scoped lang="less">
.home {
    background-color: #fff;
    height: calc(~"100vh  - 88px");
    overflow: auto;
}
</style>
